<template>
  <div id="bigButton">
    <button :disabled="isClick" class="buttons" :class="{'button_click': isClick}" @click="buttonClick">
      <slot>确认</slot>
    </button>
  </div>
</template>

<script>
export default {
  name: "bigButton",
  data() {
    return {
      isClick: false
    };
  },
  methods: {
    buttonClick() {
      this.isClick = true;
      setTimeout(() => {
        this.isClick = false;
        this.click();
      }, 100);
    }
  },
  props: ["click"]
};
</script>

<style lang="scss">
#bigButton {
  margin-top: 150px;
  .buttons {
    width:454px;
    height:88px;
    line-height:88px;
    text-align:center;
    border-radius: 44px;
    background:-webkit-gradient(linear, left top, right top, from(#898AFF), to(#5A7BFF));
    background:linear-gradient(90deg, #898AFF, #5A7BFF);
    color:#fff;
    font-size:32px;
    margin:0 auto;
    display:block;
    &.button_click {
      transform-origin: center;
      transform: scale(0.9);
    }
  }
}
</style>
